var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__clip0_7824_5077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.077 9.12s-.12-1.02-.6-1.44c-.54-.6-1.14-.6-1.44-.6-2.04-.12-5.04-.12-5.04-.12s-3 0-5.04.12c-.3.06-.9.06-1.44.6-.42.42-.6 1.44-.6 1.44s-.12 1.14-.12 2.34v1.08c0 1.14.12 2.34.12 2.34s.12 1.02.6 1.44c.54.6 1.26.54 1.56.6 1.14.12 4.92.12 4.92.12s3 0 5.04-.18c.3-.06.9-.06 1.44-.6.42-.42.6-1.44.6-1.44s.12-1.14.12-2.34V11.4c0-1.14-.12-2.28-.12-2.28zm-8.58 4.74V9.84l3.9 2.04-3.9 1.98z",
    fill: "#0D0C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__clip0_7824_5077"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgYoutube;